import PropTypes from 'prop-types';

import { getContent } from '@/utils/helper';

import Text from '@/atoms/Text/Text';
import BlockText from '@/molecules/BlockText/BlockText';

import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function ContactItem({ fields, entries }) {
  return (
    <div className="flex flex-col container mx-auto mt-[49px]">
      <Text tag="tag" style="text-black">
        {fields?.name}
      </Text>
      {fields?.description?.sys?.id && (
        <BlockText
          entries={entries}
          blockWrapperStyle="px-0 md:px-0 md:pb-5"
          fields={getContent(fields.description.sys.id, entries)?.fields}
          noGap
          richTextStyle={{
            paragraph: {
              blockquoteFont: TEXT_BASE_CLASS['h6'] + ' text-acacia',
              customFont: TEXT_BASE_CLASS['body'] + ' text-dark-warm-grey',
            },
          }}
        />
      )}
    </div>
  );
}

export function ContactDescription({ fields }) {
  return (
    <div className="flex flex-col container mx-auto">
      <Text tag="h5" style="text-dark-warm-grey">
        {fields?.text}
      </Text>
    </div>
  );
}

ContactItem.propTypes = {
  fields: PropTypes.object,
  entries: PropTypes.array,
};
